import styled from 'styled-components';

export const Block = styled.div`
    width: 100%;

    * {
        width: 100%;
    }
`;

export const FlexBlock = styled.div`
    width: auto;
    display: flex;
    gap: 16px;
`;
